import React from 'react';
const Footer =() =>{
    return(
        <>
            <footer className=" my-5 ml-10 w-100  text-center">
                <p>All copyrights reserved by sn softwaresolutions</p>
            </footer>
        </>
    )
}

export default Footer;